import { getTracker } from '@better-apply/tracking-package';
import {
  getInternalTrackingEndpoint,
  getInternalTrackingApiKey,
  isInternalTrackingEnabled,
} from '../../../utils/internalTracking';

export { isInternalTrackingEnabled, getInternalTrackingEndpoint, getInternalTrackingApiKey };

export const internalProvider = {
  name: 'internal',

  isAvailable() {
    if (!isInternalTrackingEnabled()) return false;
    if (!getInternalTrackingEndpoint()) return false;

    try {
      getTracker();
      return true;
    } catch {
      return false;
    }
  },

  track(eventName, payload = {}, options = {}) {
    if (!this.isAvailable()) return;

    if (process.env.REACT_APP_ENV !== 'production') {
      console.log('[Tracking] Internal', eventName, payload, options);
    }

    try {
      const tracker = getTracker();

      if (options.isPageView || eventName === 'pageview') {
        tracker.trackPageView(payload);
        return;
      }

      tracker.trackEvent(eventName, payload);
    } catch {
      // Tracker not initialised — ignore
    }
  },
};
